import { Component } from '@angular/core';

@Component({
    selector: 'app-identity-provider',
    templateUrl: './identity-provider.component.html',
    styleUrls: ['./identity-provider.component.scss'],
    standalone: false
})
export class IdentityProviderComponent {}
